import { render, staticRenderFns } from "./Historico.vue?vue&type=template&id=521aa5d4&scoped=true&"
import script from "./Historico.vue?vue&type=script&lang=js&"
export * from "./Historico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521aa5d4",
  null
  
)

export default component.exports